var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8625 4.89961C15.8625 4.27508 15.3461 3.64961 14.6125 3.64961C13.9012 3.64961 13.2657 4.25702 13.3625 5.00067V14.3918L10.9914 12.0207C10.6918 11.7211 10.3786 11.6121 10.0625 11.6121C9.89193 11.6121 9.70917 11.6674 9.55212 11.7399C9.39395 11.8129 9.24152 11.9127 9.13357 12.0207C8.61797 12.5363 8.61797 13.3629 9.13357 13.8785L13.5961 18.341C13.8957 18.6406 14.2088 18.7496 14.525 18.7496C14.6956 18.7496 14.8783 18.6943 15.0354 18.6218C15.1935 18.5488 15.346 18.449 15.4539 18.341L20.0914 13.7035C20.607 13.1879 20.607 12.3613 20.0914 11.8457C19.7918 11.5461 19.4786 11.4371 19.1625 11.4371C18.9919 11.4371 18.8092 11.4924 18.6521 11.5649C18.494 11.6379 18.3415 11.7377 18.2336 11.8457L15.8625 14.2168V4.89961Z",
    fill: "#1FA37C",
    stroke: "#1FA37C",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76251 24.8377H24.85C25.5291 24.8377 25.975 24.2717 25.975 23.7127V16.4502C25.975 16.1309 25.8675 15.8454 25.6612 15.639C25.4548 15.4327 25.1693 15.3252 24.85 15.3252C24.5307 15.3252 24.2452 15.4327 24.0389 15.639C23.8325 15.8454 23.725 16.1309 23.725 16.4502V22.5877H4.88751V16.4502C4.88751 16.1309 4.77998 15.8454 4.57366 15.639C4.36734 15.4327 4.08182 15.3252 3.76251 15.3252C3.4432 15.3252 3.15768 15.4327 2.95136 15.639C2.74504 15.8454 2.63751 16.1309 2.63751 16.4502V23.7127C2.63751 24.032 2.74504 24.3175 2.95136 24.5238C3.15768 24.7302 3.4432 24.8377 3.76251 24.8377Z",
    fill: "#1FA37C",
    stroke: "#1FA37C",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.08bafbfc3f762f1b9b5636517d80bc23.svg";
export { ForwardRef as ReactComponent };